import React from 'react'

const AdminHome: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4473_29154)" />
    <path
      d="M16.9193 52.5C16.9193 47.3372 16.9193 42.1106 16.9193 36.884C22.7833 36.884 28.5835 36.884 34.4475 36.884C34.4475 41.5369 34.4475 46.1261 34.4475 50.8428C36.3596 50.8428 38.208 50.8428 40.0565 50.8428C40.0565 51.4164 40.0565 51.9264 40.0565 52.5C32.3441 52.5 24.6317 52.5 16.9193 52.5Z"
      fill="white"
    />
    <path
      d="M27.7548 25.7297C27.8822 22.9252 29.2208 20.2482 32.2165 18.5273C35.6584 16.5514 39.9926 17.5075 42.5421 20.6944C45.3466 24.2 45.0917 29.3629 41.9685 32.6135C38.0167 36.7565 31.2604 35.6092 28.7108 30.4464C28.0735 29.1079 27.7548 27.8331 27.7548 25.7297Z"
      fill="white"
    />
    <path
      d="M44.1356 51.4165C43.2433 51.5439 42.4147 51.6714 41.5861 51.8626C41.5861 51.034 41.5861 50.2692 41.5861 49.4406C39.6739 49.4406 37.8255 49.4406 35.9771 49.4406C35.9771 45.8712 35.9771 42.3656 35.9771 38.7325C36.1045 38.7962 36.1683 38.8599 36.2957 38.9237C37.6343 37.9038 38.909 36.884 40.2475 35.8005C40.5025 35.6093 40.6937 35.5455 41.0124 35.673C44.2631 36.5653 47.3225 37.9038 49.8083 40.1984C51.593 41.8556 52.7403 43.8315 53.059 46.2536C53.1865 47.0822 52.7403 47.9108 51.9755 48.357C51.7205 46.8273 50.8919 45.7437 49.5534 45.0426C48.4698 44.5327 47.3225 44.5327 46.239 44.9151C44.1356 45.6162 42.3509 48.4845 44.1356 51.4165Z"
      fill="white"
    />
    <path
      d="M50.8922 48.9306C50.8922 50.6516 49.4262 52.1175 47.7053 52.1175C45.9206 52.1175 44.5183 50.8428 44.4546 49.0581C44.3909 47.2097 45.7931 45.7437 47.6415 45.7437C49.4262 45.6799 50.8922 47.1459 50.8922 48.9306Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4473_29154"
        x1="34.5455"
        y1="2.70945e-07"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EA1225" />
        <stop offset="1" stopColor="#BA0B1B" />
      </linearGradient>
    </defs>
  </svg>
)

export default AdminHome
